import {
  CaretDownOutlined,
  CaretUpOutlined,
  EyeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { MdDelete } from "react-icons/md";
import "../../../styles/table.scss";
import "./style.scss";
import {useInfoUser} from "../../../store/UserStore";

const MobileCardTable = ({
  dataSource = [],
  columns = [],
  handleRowClick,
  addMoreSubTask,
  permissionCurrentUser,
  deleteTask,
}) => {
  const [expandedKeys, setExpandedKeys] = useState([]);
  const heightMap = useRef({});
  const nodeRefs = useRef({});
  const [data, setData] = useState(dataSource);
  const { user, languageMap } = useInfoUser();

  useEffect(() => {
    setData(dataSource);
  }, [dataSource]);

  useEffect(() => {
    Object.entries(nodeRefs.current).forEach(([key, ref]) => {
      if (ref?.current) {
        heightMap.current[key] = ref?.current.offsetHeight;
      }
    });
  }, [expandedKeys]);

  const toggleExpand = (key) => {
    setExpandedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const renderCards = (items, level = 0) => {
    const lineLeft = level;

    const colors = [
      "#1677ff", // Blue (primary)
      "#52c41a", // Green
      "#722ed1", // Purple
      "#fa8c16", // Orange
      "#eb2f96", // Pink
    ];
    const borderColor = colors[level % colors.length];
    const parentBorderColor = colors[(level - 1) % colors.length];

    return items.flatMap((item) => {
      const isExpanded = expandedKeys.includes(item?.key);
      const hasChildren =
        Array.isArray(item?.children) && item?.children?.length > 0;

      if (!nodeRefs.current[item?.key]) {
        nodeRefs.current[item?.key] = React.createRef();
      }

      return (
        <div
          key={item?.key}
          className="relative mb-3"
          ref={nodeRefs.current[item?.key]}
          style={{
            marginLeft: `${lineLeft + 2}px`,
            borderRadius: "10px",
          }}
        >
          {hasChildren && isExpanded && (
            <div
              className="absolute top-[20px] left-0 w-[2px]"
              style={{
                height: `calc(100% - 20px)`,
                backgroundColor: borderColor,
                marginLeft: `-2px`,
              }}
            ></div>
          )}

          {level !== 0 && (
            <div
              className="absolute top-[14px] right-[100%] w-[15px] h-[2px] transform translate-y-[-50%]"
              style={{
                backgroundColor: parentBorderColor,
                borderRadius: "5px",
                transform: "rotate(45deg)",
              }}
            ></div>
          )}

          <div
            className={`relative p-2 rounded-xl shadow hover:shadow-md transition-all mb-2 bg-white`}
          >
            <div className="flex justify-between flex-col items-start gap-4">
              <div
                className="text-sm font-bold text-gray-700 w-full flex flex-col gap-2"
                style={{ color: borderColor }}
              >
                {item?.name}
                {item?.status}
                <div className="flex justify-between items-center">
                  {item?.startDate} - {item?.endDate}
                </div>
                {item?.progressRate}
                {item?.assignee?.props?.children?.length > 0 && item?.assignee}
              </div>

              <div className="flex gap-2 w-full justify-end items-center flex-wrap">
                {hasChildren && (
                  <Button
                    size="small"
                    icon={
                      isExpanded ? <CaretUpOutlined /> : <CaretDownOutlined />
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleExpand(item?.key);
                    }}
                    style={{
                      backgroundColor: isExpanded ? "#F87171" : "#1677ff",
                      color: "#fff",
                      border: "none",
                      borderRadius: 6,
                    }}
                  >
                    {isExpanded ? languageMap?.["timeline.mobile.buttonCollapse"] ?? "Thu gọn" : languageMap?.["timeline.mobile.buttonExpand"] ?? "Mở rộng"}
                  </Button>
                )}

                {typeof item?.name?.props?.children === "string" &&
                  item?.name?.props?.children?.trim() && (
                    <Button
                      icon={<EyeOutlined />}
                      size="small"
                      className="bg-[#1677ff] hover:bg-amber-600 text-white border-none rounded-md"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRowClick(e, item);
                      }}
                    >
                      {languageMap?.["timeline.mobile.buttonViewDetails"] ?? "Chi tiết"}
                    </Button>
                  )}

                {level < 3 &&
                  typeof item?.name?.props?.children === "string" &&
                  item?.name?.props?.children?.trim() && (
                    <Button
                      icon={<PlusOutlined />}
                      size="small"
                      hidden={!permissionCurrentUser?.includes("C")}
                      className="bg-[#1677ff] hover:bg-emerald-600 text-white border-none rounded-md"
                      onClick={(e) => {
                        e.stopPropagation();
                        const getKey = item?.path || item?.key;
                        if (!expandedKeys.includes(getKey)) {
                          setExpandedKeys((prev) => [...prev, getKey]);
                        }
                        addMoreSubTask(item?.path || item?.key);
                      }}
                    >
                      {languageMap?.["timeline.mobile.buttonAddMore"] ?? "Thêm task"}
                    </Button>
                  )}

                <Button
                  icon={<MdDelete color="#fff" />}
                  size="small"
                  className="bg-red-500 hover:bg-red-600 text-white border-none rounded-md"
                  hidden={!permissionCurrentUser?.includes("D")}
                  onClick={() => deleteTask(item?.path || item?.key)}
                >
                  {languageMap?.["timeline.mobile.buttonDelete"] ?? "Xóa"}
                </Button>
              </div>
            </div>
          </div>

          {hasChildren && isExpanded && (
            <div className="ml-2">{renderCards(item?.children, level + 1)}</div>
          )}
        </div>
      );
    });
  };

  return (
    <div className="mobile-card-table bg-gray-50">{renderCards(data)}</div>
  );
};

export default MobileCardTable;
